import React from "react";
import { Provider } from "react-redux";
import { ToastContainer } from "react-toastify";
import { BrowserRouter } from "react-router-dom";

import "react-toastify/dist/ReactToastify.css";

import Pages from "./components/layout/pages/Pages";
import GlobalCSS from "./components/layout/GlobalCSS";
import { CrmThemeProvider } from "./globalStyles";
import GlobalContextProvider from "./components/contexts/GlobalContext";
import AuthTokenProvider from "./components/contexts/AuthTokenContext";

import { store } from "./redux/store";

const App = () => {
  return (
    <>
      <BrowserRouter>
        <CrmThemeProvider>
          <GlobalCSS />
          <AuthTokenProvider>
            <Provider store={store}>
              {/* `EnumsContextProvider` and `DataContextProvider` used to wrap these — both were
                  caches, and the RTK Query store above is the cache now. */}
              <GlobalContextProvider>
                <Pages />
                <ToastContainer
                  position="top-right"
                  autoClose={3000}
                  hideProgressBar={false}
                  newestOnTop={false}
                  closeOnClick
                  rtl={false}
                  pauseOnFocusLoss
                  draggable
                  pauseOnHover
                />
              </GlobalContextProvider>
            </Provider>
          </AuthTokenProvider>
        </CrmThemeProvider>
      </BrowserRouter>
    </>
  );
};

export default App;
